import { minWidthQuery } from '@theme/coco-utilities';
if (!customElements.get('footer-menu-accordion-details')) {
class FooterAccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();

    this._open = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');
    this.setAttribute('aria-expanded', this._open ? 'true' : 'false');

    this.shouldOpenOnMobile = this.hasAttribute('data-mobile-accordion-open');
    this.defaultOpenOnMobile = this.dataset.mobileAccordionOpen === 'true';
    // this.isMobile = window.innerWidth <= 768;

    this.mediaQuery = minWidthQuery(768);
    this.isMobile = !this.mediaQuery.matches;

    this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', () => {
        if (this.designModeActive) this.open = true;
      });
      this.addEventListener('shopify:block:deselect', () => {
        if (this.designModeActive) this.open = false;
      });
    }

    // Handle initial state if accordion is present in footer with attribute
    if (this.shouldOpenOnMobile) {
      this.applyMobileDefaultState();
    }

    // window.addEventListener('resize', this.onResize.bind(this));
    this.onResize = this.onResize.bind(this);
    this.mediaQuery.addEventListener('change', this.onResize);
  }

  get designModeActive() {
    return true;
  }

  get controlledElement() {
    return this.closest('accordions-details');
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-expanded', newValue === '' ? 'true' : 'false');
    }
  }

  get open() {
    return this._open;
  }

  set open(value) {
    if (value !== this._open) {
      this._open = value;

      if (this.isConnected) {
        this.transition(value);
      } else {
        value ? this.setAttribute('open', '') : this.removeAttribute('open');
      }
    }

    this.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.dispatchEventHandler();
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this._open = false;
    this.transition(false);
  }

  transition(value) {
    this.style.overflow = 'hidden';

    // Update dimensions dynamically
    const summaryHeight = this.summaryElement.clientHeight;
    const contentHeight = this.contentElement.scrollHeight;

    if (value) {
      this.setAttribute('open', '');

      const startHeight = `${summaryHeight}px`;
      const endHeight = `${summaryHeight + contentHeight}px`;

      this.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease' }).onfinish = () => {
        this.style.height = 'auto';
        this.style.overflow = 'visible';
      };

      this.contentElement.style.opacity = 1;
      this.contentElement.style.transform = 'translateY(0)';
    } else {
      const startHeight = `${this.clientHeight}px`;
      const endHeight = `${summaryHeight}px`;

      this.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease' }).onfinish = () => {
        this.removeAttribute('open');
        this.style.height = 'auto';
        this.style.overflow = 'visible';
      };

      this.contentElement.animate(
        { opacity: [1, 0], transform: ['translateY(0)', 'translateY(10px)'] },
        { duration: 150, easing: 'ease' },
      ).onfinish = () => {
        this.contentElement.style.opacity = 0;
      };
    }
  }

  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    // Only run logic if the attribute exists
    if (!this.shouldOpenOnMobile) return;

    // If state changed between mobile and desktop
    if (this.isMobile !== wasMobile) {
      if (this.isMobile) {
        if (!this.defaultOpenOnMobile) {
          this.open = false;
        }
        // If true: do nothing, keep as open
      } else {
        this.open = true; // On desktop, always open
      }
    }
  }

  applyMobileDefaultState() {
    if (this.isMobile) {
      if (!this.defaultOpenOnMobile) {
        this.open = false;
      } else {
        this.open = true;
      }
    } else {
      this.open = true; // Always open on desktop
    }
  }

  dispatchEventHandler() {
    (this.controlledElement ?? this).dispatchEvent(
      new CustomEvent('toggle', { bubbles: true, detail: { current: this } }),
    );
  }
}
customElements.define('footer-menu-accordion-details', FooterAccordionDetails, { extends: 'details' });
}